// Custom emoji whose image does not load (a remote emoji the server has not cached,
// or a missing static version) showed as a broken image. On a load error the other
// version is tried (static <-> original); when both fail, the shortcode is shown as text.

const handleError = (event) => {
  const img = event.target;

  if (!(img instanceof HTMLImageElement) || !img.classList.contains("custom-emoji")) {
    return;
  }

  const tried = (img.dataset.failed || "").split(" ").filter(Boolean);
  const current = img.getAttribute("src");
  tried.push(current);
  img.dataset.failed = tried.join(" ");

  const next = [img.dataset.original, img.dataset.static].find(url => url && !tried.includes(url));

  if (next) {
    // Hovering swaps between the two versions, so both point to the one left.
    img.dataset.original = next;
    img.dataset.static = next;
    img.src = next;
    return;
  }

  const text = document.createElement("span");
  text.className = "custom-emoji custom-emoji--missing";
  text.textContent = img.alt;
  text.title = img.title || img.alt;
  img.replaceWith(text);
};

export const setupEmojiFallback = () => {
  // Image errors do not bubble, so listen in the capture phase.
  document.addEventListener("error", handleError, true);
};
